<template>
  <div class="sharedResortEdit">
    <template>
      <form>
        <div class="form-group">
          <h4 class="m-0 mt-3">
            {{ $t('sharedResortForms.editSharedResort') }}
          </h4>
          <hr class="m-0 mb-3">
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="includeInTop100"
              v-model="sharedResort.includeInTop100"
              class="form-check-input"
              type="checkbox"
            >
            <label
              class="form-check-label"
              for="includeInTop100"
            >Included in Top 100</label>
          </div>
          <hr class="m-0 mb-3">
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="shareTopology"
              v-model="sharedResort.shareTopology"
              class="form-check-input"
              type="checkbox"
            >
            <label
              class="form-check-label"
              for="shareTopology"
            >Share Topology</label>
          </div>
          <p
            v-if="!sharedResort.includeInTop100 && !sharedResort.shareTopology"
            style="color: red;"
          >
            At least one sharing flag must be set to true
          </p>
        </div>
        <LoadingPlaceholder v-if="loading" />
        <button
          v-else
          class="btn btn-primary float-right"
          :disabled="sharedResort == null || (!sharedResort.includeInTop100 && !sharedResort.shareTopology)"
          @click.prevent="editSharedResort()"
        >
          <font-awesome-icon
            class="mr-2"
            icon="edit"
          />{{ $t('edit') }}
        </button>
        <div class="clearfix" />
      </form>
    </template>
  </div>
</template>

<script>
import { errorMixin } from '@/mixins/errorMixin.js';

export default {
  name: "SharedResortEdit",
  mixins: [
    errorMixin
  ],
  props: {
    sharedResort: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async editSharedResort () {
      this.loading = true
      await this.axios.post(`/Resort/UpdateSharedResort?resortId=${this.sharedResort.resortId}&sharedResortId=${this.sharedResort.sharedResortId}`, this.sharedResort)
        .then(() => {
          this.loading = false
          this.$snotify.success(this.$t('sharedResortForms.editedSuccessfullySharedResort'));
          this.$emit("reload");
          this.error_clear();
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    }
  }
}
</script>

<style scoped>
.sharedResortEdit .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>